import { AnalyticsOrderFlowTypes } from '../../../common/utils/analytics-util';
import { OrderType } from '../../../common/constants/order-types';
import { ShopCartUrlContext } from '../../../common/utils/cart-util';
import { TemplateResult } from 'lit';

export enum RedeemUpsellOfferError {
  NotAuthenticated = 'upsell/notAuthenticated',
  PromoFailed = 'upsell/promoFailed',
  Generic = 'upsell/generic',
}

export interface RedeemUpsellOfferErrorContent {
  header: string;
  body: TemplateResult;
}

export interface RedeemUpsellOfferParams {
  couponCode: string;
  shopCartUrlContext: ShopCartUrlContext;
}

export declare interface SharpenUpsellPromo {
  couponCode: string;
  discountAmount: number;
  discountType: string;
  durationInDays: number;
  expirationDate: string;
  name: string;
}

export interface SharpenUpsellPromoAnalytics {
  orderType: OrderType;
  orderFlow: AnalyticsOrderFlowTypes;
}
